import React, { useContext, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import "./Login.scss";

// Images
import logo from "../../logo.png";
import loginGraphic from "../../loginGraphic.png";

// Icons //
import { IconContext } from "react-icons";
import { MdEmail } from "react-icons/md";
import { MdLock } from "react-icons/md";
import { FcGoogle } from "react-icons/fc";
import AuthContext from "../../Store/auth-context";
import { useToasts } from "react-toast-notifications";
import RoleChange from "../../utils/RoleChange";

const Email = () => {
  return (
    <IconContext.Provider
      value={{ style: { fontSize: "18px", color: "rgba(0, 0, 0)" } }}
    >
      <MdEmail />
    </IconContext.Provider>
  );
};

const Lock = () => {
  return (
    <IconContext.Provider
      value={{ style: { fontSize: "18px", color: "rgba(0, 0, 0)" } }}
    >
      <MdLock />
    </IconContext.Provider>
  );
};

const Google = () => {
  return (
    <IconContext.Provider
      value={{ style: { fontSize: "20px", margin: "0 10px 0 0" } }}
    >
      <FcGoogle />
    </IconContext.Provider>
  );
};

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPass] = useState("");
  const history = useHistory();
  const { setRoleStatus, login } = useContext(AuthContext);
  const { addToast } = useToasts();
  const FormLogin = async (e) => {
    e.preventDefault();
    const reqBody = {
      identifier: email,
      password: password,
    };
    try {
      const res = await login(reqBody);
      if (res.status === 200) {
        const ts = Math.round(new Date().getTime() / 1000);
        setEmail(res.data.user.email);
        localStorage.setItem("email", res.data.user.email);
        if (res.data.user.isActive === true) {
          setRoleStatus(true);
        } else if (
          res.data.user.isActive === false &&
          res.data.user.current_period_end !== null
        ) {
          await RoleChange(res.data.isActive, reqBody.identifier);
        } else {
          setRoleStatus(false);
        }
        addToast("Successfully logged in", {
          appearance: "success",
          autoDismiss: "true",
        });
        setTimeout(() => {
          history.push("/");
        }, 1000);
      } else {
        addToast("Input Correct infos", { appearance: "error" });
      }
    } catch (error) {
      console.log(error);
      addToast(`${error.response.data.error.message}`, { appearance: "error" });
    }
  };
  const GoogleLogin = () => {
    console.log("ok");
    history.replace("/connect/google/redirect");
  };
  return (
    <div id="login">
      <div className="row pageHeight">
        <div className="col-lg loginBackground">
          <div className="loginField">
            <Link to="/">
              <img className="loginLogo" src={logo} alt="logo" />
            </Link>
            <h1>Login</h1>
            <h2>
              Get the best sports betting picks from our elite capncovers team.
            </h2>

            {/* <button type="button" className="btn googleButton" onClick={GoogleLogin}><Google />Sign in with Google</button>

                        <div className='emailOption'><p><span>or sign in with email</span></p></div> */}

            <form onSubmit={FormLogin}>
              <div className="input-group mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <Email />
                </span>
                <input
                  type="email"
                  className="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <Lock />
                </span>
                <input
                  type="password"
                  className="form-control"
                  id="exampleInputPassword1"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPass(e.target.value)}
                />
              </div>
              <button type="submit" className="btn loginButton mb-2">
                Login
              </button>
              <Link to="/register/">
                Don't have an account? Create one here.
              </Link>
            </form>
          </div>
        </div>

        <div className="col-lg rightBackground">
          <div className="rightField">
            <img
              className="loginGraphic"
              src={loginGraphic}
              alt="Login Graphic"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
